import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap'
import { Injectable } from '@angular/core'

function parse (input: string | null): NgbDateStruct|null {
  let output: any = null
  if (input) {
    const segments = input.trim().split(/[./]/g)
    if (segments.length === 3) {
      output = {
        day: parseInt(segments[1], 10),
        month: parseInt(segments[0], 10),
        year: parseInt(segments[2], 10),
      }
    }
  }
  return output
}

function stringify (date: NgbDateStruct | null): string {
  return date ? [`0${date.month}`.slice(-2), `0${date.day}`.slice(-2), date.year].join('/') : ''
}

@Injectable()
export class NgbDatepickerParserFormatter extends NgbDateParserFormatter {
  parse (value: string): NgbDateStruct | null {
    return parse(value)
  }

  format (date: NgbDateStruct | null): string {
    return stringify(date)
  }
}

@Injectable()
export class NgbDatepickerAdapter extends NgbDateAdapter<string> {
  fromModel (value: string | null): NgbDateStruct|null {
    return parse(value)
  }

  toModel (date: NgbDateStruct | null): string | null {
    return stringify(date)
  }
}
